import { SortOrder } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export const sortPair = <T extends string>(
  orderByColumn: T,
  primaryText: string,
  ascText: string,
  descText: string,
) =>
  [SortOrder.Asc, SortOrder.Desc].map((sortOrder) => ({
    name: `${orderByColumn}_${sortOrder}`,
    orderByColumn,
    sortOrder,
    primaryText,
    secondaryText: sortOrder === SortOrder.Asc ? ascText : descText,
    title: $t('Order by :field', { field: primaryText.toLowerCase() }),
  }))
